import styled from 'styled-components';

import * as icons from '@creditornot/alchemy-react/icons';
import { IconButton } from '@creditornot/cb-button';

const Root = styled.div`
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

type RowToggleProps = {
  isExpanded: boolean;
  canExpand: boolean;
  toggleExpanded: () => void;
};

export const RowExpand = ({ isExpanded, canExpand, toggleExpanded }: RowToggleProps) => {
  if (!canExpand) {
    return null;
  }

  return (
    <Root>
      {canExpand && (
        <IconButton
          data-test-id="row-expand-button"
          size="tiny"
          styleParams={{
            size: '32px',
          }}
          background="transparent"
          variant="subdued"
          onClick={(e) => {
            toggleExpanded();
            e.stopPropagation();
          }}
          icon={isExpanded ? icons.chevronUp : icons.chevronDown}
        />
      )}
    </Root>
  );
};
